import { Button, FlexBox, Link, useScreenClass } from '@vp/swan'
import UploadFlow from '@vp/upload-flow'

import { useAppContext } from '../../state/AppContext'
import PricingContext from '../../services/serviceClients/PricingContext'
import PageConfig from '../../utils/pageConfig'
import { trackNavigationClicks } from '../../utils/tracking/tracking'

interface StockOptionCTAProps {
  browseDesign: string
  browseDesignCta: string
  uploadDesignCta: string
  productName: string
  productId: string
  mpvId: string
  version: number
  quantity: number
  tabIndex: number
  disableUploadFlow: boolean
  isOutOfStock: boolean
}

const StockOptionCTA = (props: StockOptionCTAProps) => {
  const {
    browseDesign,
    browseDesignCta,
    uploadDesignCta,
    productName,
    productId,
    mpvId,
    version,
    quantity,
    tabIndex,
    disableUploadFlow,
    isOutOfStock
  } = props

  const isMobile = useScreenClass() === 'xs'
  const { merchandisingCategoryId, locale, vatInclusivity } = useAppContext()

  return (
    <FlexBox
      flexWrap={isMobile ? 'wrap' : 'unset'}
      gap="between-actions"
      flexDirection="row"
      marginTop={6}
    >
      {browseDesign && (
        <Button
          skin={isOutOfStock ? null : 'primary'}
          width="full-width"
          render={(props) => (
            <Link
              to={isOutOfStock ? null : browseDesign}
              className={props.className}
              aria-disabled={isOutOfStock}
              onClick={
                isOutOfStock
                  ? undefined
                  : () => {
                      trackNavigationClicks({
                        categoryId: merchandisingCategoryId,
                        pageZone: 'stockOptions',
                        destinationUrl: browseDesign,
                        tabIndex: tabIndex + 1,
                        stockOptionsCtaText: 'Browse Designs'
                      })
                    }
              }
            >
              {props.children}
            </Link>
          )}
        >
          {browseDesignCta}
        </Button>
      )}

      {!disableUploadFlow && (
        <UploadFlow
          vatInc={vatInclusivity}
          analyticsPageData={{
            pageSection: 'Category Page',
            pageStage: 'Discover',
            pageName: `${merchandisingCategoryId}:Category Page`,
            productName,
            coreProductId: productId,
            // @ts-expect-error Label is needed but missing in type definition
            label: `Options Display:stockOptions:${tabIndex + 1}`
          }}
          tenant={PageConfig.tenant}
          locale={locale}
          pricingContextString={PricingContext.getPricingContext()}
          mpvId={mpvId}
          loader={
            <Button skin="secondary" width="full-width" disabled>
              {uploadDesignCta}
            </Button>
          }
          productKey={productId}
          productName={productName}
          productVersion={version}
          quantity={quantity}
          requestor={PageConfig.requestor}
        >
          <Button skin="secondary" width="full-width" disabled={isOutOfStock}>
            {uploadDesignCta}
          </Button>
        </UploadFlow>
      )}
    </FlexBox>
  )
}

export default StockOptionCTA
